<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>

<mapfre-modal 
    [modalOptions]="enrollEditModalOptions" 
    [hideModal]="hideModal" 
    (hideModalOutput)="resetHideModal()"
    (openModal)="onOpenModal()"
>
    <div class="modal-body eft-confirm-container-modal">
        <div class="text-center">
            <div class="modal-icon-box-center">
                <img src={{modalIcon}} alt="unenroll icon"/>
            </div>
            <div class="autopay-title modal-title-width">
                Enroll your {{ policy?.displayType?.label | lowercase }} policy 
                {{ policy?.policynumber.policyNumber }} in autopay
            </div>
        </div>

        <div class="payment-method-col mt-3">
            <div class="payment-info-btn">
                <div class="payment-info-col"> 
                    <div class="payment-type-info">
                        {{ 'Checking/savings account' }}
                    </div>
                    <div class="details width-web-332">
                        {{ 'To set up your autopay details, simply enter your bank account details.' }}
                    </div>
                </div>   
                <mapfre-button (click)="onCheckingSavingAccountClick()" additionalClasses="basic primary w-100-mobile" >
                    {{ "Enroll" | translate }}
                </mapfre-button>
            </div>  

            <div class="payment-info-btn">
                <div class="payment-info-col"> 
                    <div class="payment-type-info">
                        {{ 'Credit/debit card' }}
                    </div>
                    <div class="details width-web-332">
                        {{ 'You will be redirected to Paymentus to add the details.' }}
                    </div>
                </div>
                <mapfre-button (click)="onCreditDebitCardClick()" additionalClasses="basic primary w-100-mobile" >
                    {{ "Enroll" | translate }}
                </mapfre-button>
            </div>
        </div>

        <hr class="devided-line mt-4 mb-4"/>
        <div class="mx-auto align-text-right">
            <div>                              
                <mapfre-button 
                    additionalClasses="ghost secondary large-btn" 
                    (click)="hideModalAction($event)"
                >
                    {{ 'CANCEL' | translate }}
                </mapfre-button>
            </div>
        </div>
    </div>
</mapfre-modal>